import {
  deleteApiGreetingsId,
  getApiGreetingsId,
  patchApiGreetingsStatus,
  postApiGreetings,
  putApiGreetingsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const greetingByIdQuery = createQuery({
  handler: getApiGreetingsId,
})

export const greetingCreate = createMutation({
  handler: postApiGreetings,
})

export const greetingUpdate = createMutation({
  handler: putApiGreetingsId,
})

export const greetingDelete = createMutation({
  handler: deleteApiGreetingsId,
})

export const greetingsStatus = createMutation({
  handler: patchApiGreetingsStatus,
})
